"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddShipmentLine = void 0;
const class_validator_1 = require("class-validator");
const common_1 = require("../../common");
class AddShipmentLine extends common_1.BaseAction {
}
__decorate([
    class_validator_1.IsMongoId()
], AddShipmentLine.prototype, "shipmentHeaderId", void 0);
__decorate([
    class_validator_1.IsMongoId()
], AddShipmentLine.prototype, "orderReleaseId", void 0);
__decorate([
    class_validator_1.IsNumber(),
    class_validator_1.Min(1)
], AddShipmentLine.prototype, "requiredQuantity", void 0);
exports.AddShipmentLine = AddShipmentLine;
//# sourceMappingURL=add-shipment-line.action.js.map